{
  "_meta": {
    "_comment": "merchant-v3 catalog namespace FR. CatalogSidebar left rail + Task 35 copack browse.",
    "locale": "fr",
    "completeness": "secondary",
    "vg-binding": "P14.1.D-15,P14.1.D-16"
  },
  "sidebar": {
    "categories": "Catégories",
    "filters": "Filtres",
    "priceRange": "Fourchette de prix",
    "min": "Min",
    "max": "Max"
  },
  "copack": {
    "page": {
      "title": "Groupes d'expédition mutualisés",
      "subtitle": "Parcourez les groupes d'expédition consolidés pour réduire les frais."
    },
    "filter": {
      "label": "Filtrer par blueprint",
      "placeholder": "ID blueprint",
      "apply": "Appliquer",
      "clear": "Effacer"
    },
    "table": {
      "groupKey": "Groupe",
      "location": "Lieu",
      "packingClass": "Classe d'emballage",
      "blueprints": "Blueprints",
      "shipping": "Frais d'expédition (exemple)",
      "additional": "Article supplémentaire"
    },
    "blueprintsCount_one": "{{count}} blueprint",
    "blueprintsCount_other": "{{count}} blueprints",
    "state": {
      "loading": "Chargement des groupes…",
      "empty": {
        "title": "Aucun groupe mutualisé",
        "body": "Aucun groupe d'expédition consolidé ne correspond au filtre."
      },
      "error": "Impossible de charger les groupes.",
      "retry": "Réessayer"
    },
    "pagination": {
      "page": "Page {{page}} sur {{pages}}",
      "prev": "Précédent",
      "next": "Suivant"
    }
  }
}
